import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "form-upload-img-icon-area" }
const _hoisted_3 = { class: "ant-upload-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oio_icon = _resolveComponent("oio-icon")!
  const _component_plus_outlined = _resolveComponent("plus-outlined")!
  const _component_FileUpload = _resolveComponent("FileUpload")!
  const _component_a_image = _resolveComponent("a-image")!

  return (_openBlock(), _createElementBlock("div", {
    class: "oio-default-upload-img",
    onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createVNode(_component_FileUpload, {
      value: _ctx.fileList,
      listType: "picture-card",
      limit: _ctx.limit,
      "limit-size": _ctx.limitSize,
      "all-limit-size": _ctx.allLimitSize,
      accept: _ctx.limitFileExtensions || '.jpg,.jpeg,.png,.gif,.bmp',
      disabled: _ctx.disabled,
      readonly: _ctx.readonly,
      multiple: _ctx.multiple,
      onChange: _ctx.onChangeFile,
      onRemove: _ctx.onRemoveFile,
      onPreview: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handlePreview(true, $event)))
    }, {
      default: _withCtx(() => [
        (
          !_ctx.readonly &&
          (!_ctx.value ||
            (Array.isArray(_ctx.value)
              ? _ctx.limit && (_ctx.limit === -1 || _ctx.value.length < _ctx.limit)
              : Object.keys(_ctx.value).filter((name) => !name.includes('_')).length === 0))
        )
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                (_ctx.uploadIcon)
                  ? (_openBlock(), _createBlock(_component_oio_icon, {
                      key: 0,
                      icon: _ctx.uploadIcon,
                      size: "14"
                    }, null, 8, ["icon"]))
                  : (_openBlock(), _createBlock(_component_plus_outlined, { key: 1 })),
                _createTextVNode(" " + _toDisplayString(_ctx.uploadIconText), 1)
              ]),
              _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.uploadPlaceholder || (_ctx.translate && _ctx.translate('kunlun.button.upload')) || '点击上传'), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["value", "limit", "limit-size", "all-limit-size", "accept", "disabled", "readonly", "multiple", "onChange", "onRemove"]),
    _createVNode(_component_a_image, {
      style: { display: 'none' },
      src: _ctx.previewImage,
      preview: { visible: _ctx.visible, onVisibleChange: _ctx.handlePreview }
    }, null, 8, ["src", "preview"])
  ]))
}